// Libs
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const MealsToAddForDateButton = ({ hiddenDays, formattedDate, disabled, setMenuModal }) => {
    return (
        <>
            {hiddenDays.indexOf(+formattedDate.format("d")) === -1 ? (
                <button
                    className="btn btn-success btn-sm"
                    style={{ marginTop: -9 }}
                    disabled={disabled}
                    onClick={() => setMenuModal({ show: true, date: formattedDate })}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            ) : (
                <></>
            )}
        </>
    )
}

export default MealsToAddForDateButton;